import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function Menu() {
  return (
    <Navbar bg="dark" variant="dark">
      <Container>
        {/* Brand with Logo */}
        <Navbar.Brand
          as={Link}
          to="/"
          className="d-flex align-items-center"
        >
          <img
            src="/logo192.png"
            alt="Video Upload"
            width="32"
            height="32"
            className="me-2"
          />
        </Navbar.Brand>

        <Nav>
          <Nav.Link as={Link} to="/">Direct Upload</Nav.Link>
          <Nav.Link as={Link} to="/frontend-compress">
            Frontend Compress
          </Nav.Link>
          <Nav.Link as={Link} to="/compressed-list">
            Videos
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default Menu;
